import styled, { css } from 'styled-components';
import { em } from 'polished';
import { colors } from 'core/theme';

const MAP = {
  default: [16, 24],
  small: [14, 20],
  medium: [18, 28],
  large: [22, 30],
}

const fontSize = ({size}) => {
  return MAP[size];
};

const fontSizeInEm = ({size}) => {
  const [fontSizeInPx] = fontSize({size});
  return em(fontSizeInPx);
};

const lineHeight = ({size}) => {
  const [fontSizeInPx, lineHeightInPx] = fontSize({size});
  return lineHeightInPx / fontSizeInPx;
};

export const ParagraphStyle = (props) => css`
  color: ${colors.subtleText};
  font-size: ${fontSizeInEm(props)};
  line-height: ${lineHeight(props)};

  &:not(:empty) {
    margin: 1em 0;
  }
`;

export const StyledParagraph = styled.p`
  ${props => ParagraphStyle(props)};
`;



// WEBPACK FOOTER //
// ./src/elements/Paragraph/styled.js